// extracted by mini-css-extract-plugin
export default {"home":"Homepage_home__48Pqf","text":"Homepage_text__hof1Z","tqColor":"Homepage_tqColor__bh-AM","main":"Homepage_main__-W2sb"};